import { gql } from '@apollo/client'

export const GET_ALL_FORM_FIELDS_YUP_RULES_BY_FIELD_ID = gql`
  query GetAllFormFieldYupRulesByFieldId($fieldId: Int!) {
    getAllFormFieldYupRulesByFieldId(fieldId: $fieldId) {
      id
      field_id
      yup_rule_id
      YupRuleOfField {
        id
        description
        yup_type
        yup_rule
        options
        message
      }
    }
  }
`

export const GET_ALL_YUP_RULES_AVAILABLE_FOR_FIELD = gql`
  query GetAllYupRulesAvailableForField($fieldId: Int!) {
    getAllYupRulesAvailableForField(fieldId: $fieldId) {
      id
      description
      yup_type
      yup_rule
      options
      message
    }
  }
`

export const CREATE_FORM_FIELD_YUP_RULE = gql`
  mutation CreateFormFieldYupRule($fieldId: Int!, $yupRuleId: Int!) {
    createFormFieldYupRule(fieldId: $fieldId, yupRuleId: $yupRuleId)
  }
`

export const DELETE_FORM_FIELD_YUP_RULE = gql`
  mutation DeleteFormFieldYupRule($id: Int!) {
    deleteFormFieldYupRule(id: $id)
  }
`
